import React from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";

export default function ContactUs() {
  return (
    <div className="bg-white min-h-screen">
      
      <div className="max-w-7xl mx-auto px-4 py-12 -mt-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden grid md:grid-cols-2">
          
          {/* LEFT: Contact Info */}
          <div className="bg-[#003580] p-10 text-white flex flex-col justify-between">
            <div>
              <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
              <p className="text-blue-100 mb-10 leading-relaxed">
                Whether you have a question about property availability, pricing, or listing your own home, our team is ready to answer all your questions.
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-white/10 p-3 rounded-lg">
                    <Phone size={20} className="text-yellow-400" />
                  </div>
                  <div>
                    <p className="text-sm text-blue-200 font-medium">Phone</p>
                    <p className="font-semibold">+971 50 5069469</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-white/10 p-3 rounded-lg">
                    <Mail size={20} className="text-yellow-400" />
                  </div>
                  <div>
                    <p className="text-sm text-blue-200 font-medium">Email</p>
                    <p className="font-semibold">info@highendholidays.ae</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-white/10 p-3 rounded-lg">
                    <MapPin size={20} className="text-yellow-400" />
                  </div>
                  <div>
                    <p className="text-sm text-blue-200 font-medium">Office</p>
                    <p className="font-semibold">
                      Office:- Al Qouz,<br />
                      Dubai, UAE
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Socials / Bottom decoration */}
            <div className="mt-12">
              <p className="text-sm text-blue-200">Follow us @highend.holidays</p>
            </div>
          </div>

          {/* RIGHT: Contact Form */}
          <div className="p-10 bg-white">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Send us a Message</h2>
            
            <form className="space-y-5">
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                <input 
                  type="email" 
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea 
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                  placeholder="How can we help you?"
                ></textarea>
              </div>

              <button 
                type="button"
                className="w-full bg-[#003580] hover:bg-blue-800 text-white font-bold py-3 rounded-lg transition duration-300 flex items-center justify-center gap-2"
              >
                Send Message
                <Send size={18} />
              </button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
}